import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
	ProgressBar,
	Table,
	Grid,
	Row,
	Col
} from '../../node_modules/react-bootstrap/lib/';

import {
	BootstrapTable,
	TableHeaderColumn
} from 'react-bootstrap-table';

import {
	Pedestrismo,
	PedestrismoBackup,
	CombinadaSimple,
	CombinadaSprint,
	RuralBike
} from '../constants/enums';


class RaceStats extends Component {

	constructor(props) {

		super(props);

		this.options = {
			defaultSortName: 'y',
			defaultSortOrder: 'desc',
			noDataText: 'Sin datos',
			sizePerPage: 50,
			paginationSize: 2,
			paginationPosition: 'bottom'
		};

		this.options2 = {
			noDataText: 'Sin datos',
			sizePerPage: 50,
			paginationSize: 2,
			paginationPosition: 'bottom'
		};

		this.state = {
			completion1: 0,
			completion2: 0,
			completion3: 0
		};
	}


	removeDuplicates(myArr, prop) {

		return myArr.filter(
			(obj, pos, arr) => {

				return (
					arr
						.map(
							mapObj =>
								mapObj[prop]
						)
						.indexOf(
							obj[prop]
						) === pos
				);
			}
		);
	}


	getCityDistribution() {

		let participants =
			this.props.infoList.slice(0);

		let cities = [];

		let dup =
			this.removeDuplicates(
				participants,
				'city'
			);


		for (
			let i = 0;
			i < dup.length;
			i++
		) {

			let city =
				dup[i].city;

			let counter = 0;


			for (
				let j = 0;
				j < participants.length;
				j++
			) {

				if (
					participants[j].city === city
				) {

					counter++;
				}
			}


			cities.push({
				id: i,
				x: city,
				y: counter
			});
		}


		return cities;
	}


	getGenderDistribution() {

		let participants =
			this.props.infoList.slice(0);

		let genders = [];

		let dup =
			this.removeDuplicates(
				participants,
				'gender'
			);


		for (
			let i = 0;
			i < dup.length;
			i++
		) {

			let gender =
				dup[i].gender;

			let counter = 0;


			for (
				let j = 0;
				j < participants.length;
				j++
			) {

				if (
					participants[j].gender === gender
				) {

					counter++;
				}
			}


			genders.push({
				id: i,
				x: gender,
				y: counter
			});
		}


		return genders;
	}


	getCategoryDistribution() {
		console.log(this.props.catStats)
		let categories =
			this.props.catStats
				.slice()
				.sort(
					(p1, p2) => {

						return (
							parseInt(
								p1.order,
								10
							) <
							parseInt(
								p2.order,
								10
							)
								? -1
								: 1
						);
					}
				);


		let result = [];


		for (
			let i = 0;
			i < categories.length;
			i++
		) {

			result.push({
				id: i,
				x: categories[i]['category'],
				y: categories[i]['total']
			});
		}


		return result;
	}


	getInfo(param = "") {

		switch (param) {

			case "city":

				return this.getCityDistribution();


			case "gender":

				return this.getGenderDistribution();


			case "category":

				return this.getCategoryDistribution();


			default:

				return;
		}
	}


	getTotalParticipantes() {

		return this.props.infoList.length;
	}


	getTotalHombres() {

		return this.props.infoList.filter(
			(participant) => {

				return (
					participant.gender === "M"
				);
			}
		).length;
	}


	getTotalMujeres() {

		return this.props.infoList.filter(
			(participant) => {

				return (
					participant.gender === "F"
				);
			}
		).length;
	}


	getTotalEspecial(
		specialType = "0"
	) {

		if (
			this.props.competition === PedestrismoBackup ||
			this.props.competition === Pedestrismo
		) {

			return this.props.infoList.filter(
				(participant) => {

					return (
						participant.class === 'IN' &&
						participant.special === 'Especial'
					);
				}
			).length;


		} else {

			return this.props.infoList.filter(
				(participant) => {

					return (
						participant.class === 'IE' ||
						participant.class === 'PE'
					);
				}
			).length;
		}
	}


	getTotalTime(
		startedAt = 0,
		stoppedAt = 0
	) {

		let secDiff =
			Math.floor(
				(
					stoppedAt -
					startedAt
				) /
				1000
			);


		let date =
			new Date(null);


		date.setSeconds(
			secDiff
		);


		let result =
			date
				.toISOString()
				.substr(
					11,
					8
				);


		if (
			stoppedAt > 0
		) {

			return result;

		} else {

			return "00:00:00";
		}
	}


	addMinutes(
		date = null,
		minutes = 0
	) {

		return new Date(
			date.getTime() -
			minutes *
			60000
		);
	}


	getTime(
		time = 0
	) {

		let date =
			new Date(null);


		date.setSeconds(
			time /
			1000
		);


		let result =
			time > 0

				? this
					.addMinutes(
						date,
						date.getTimezoneOffset()
					)
					.toISOString()
					.substr(
						11,
						8
					)

				: date
					.toISOString()
					.substr(
						11,
						8
					);


		return result;
	}


	/*
	 * =======================================================
	 * HELPERS GENERALES DE ESTADO
	 * =======================================================
	 */

	isDNS(participant) {

		return (
			Number(
				participant.dns || 0
			) === 1
		);
	}


	isDSQ(participant) {

		return (
			Number(
				participant.disqualified || 0
			) === 1
		);
	}


	isResolved(
		participant,
		partial = 1
	) {

		let completed = false;


		if (
			partial === 1
		) {

			completed =
				participant.registeredTime1 > 0;
		}


		if (
			partial === 2
		) {

			completed =
				participant.registeredTime2 > 0;
		}


		return (
			completed ||
			this.isDNS(participant) ||
			this.isDSQ(participant)
		);
	}


	/*
	 * =======================================================
	 * PARCIALES
	 * =======================================================
	 */

	getPartial1ComplPerc() {

		const total =
			this.props.participantList.length;


		if (
			total === 0
		) {

			return 0;
		}


		const resolved =
			this.props.participantList.filter(
				(participant) => {

					return this.isResolved(
						participant,
						1
					);
				}
			);


		return (
			resolved.length *
			100 /
			total
		);
	}


	getPartial2ComplPerc() {

		const total =
			this.props.participantList.length;


		if (
			total === 0
		) {

			return 0;
		}


		const resolved =
			this.props.participantList.filter(
				(participant) => {

					return this.isResolved(
						participant,
						2
					);
				}
			);


		return (
			resolved.length *
			100 /
			total
		);
	}


	getPartialComplLabel(
		partial = 1
	) {

		const participants =
			this.props.participantList;


		const completed =
			participants.filter(
				(participant) => {

					if (
						partial === 2
					) {

						return (
							participant.registeredTime2 > 0
						);
					}


					return (
						participant.registeredTime1 > 0
					);
				}
			).length;


		const dns =
			participants.filter(
				(participant) => {

					return this.isDNS(
						participant
					);
				}
			).length;


		const dsq =
			participants.filter(
				(participant) => {

					return this.isDSQ(
						participant
					);
				}
			).length;


		const tot =
			participants.length;


		const resolved =
			completed +
			dns +
			dsq;


		const rest =
			Math.max(
				0,
				tot - resolved
			);


		let details = [];


		if (
			rest > 0
		) {

			details.push(
				'restan ' +
				rest
			);
		}


		if (
			dns > 0
		) {

			details.push(
				'DNS: ' +
				dns
			);
		}


		if (
			dsq > 0
		) {

			details.push(
				'DSQ: ' +
				dsq
			);
		}


		return (
			completed +
			'/' +
			tot +
			(
				details.length > 0
					? ' (' +
						details.join(', ') +
						')'
					: ''
			)
		);
	}


	getPartial1ComplLabel() {

		return this.getPartialComplLabel(
			1
		);
	}


	getPartial2ComplLabel() {

		return this.getPartialComplLabel(
			2
		);
	}


	/*
	 * =======================================================
	 * HELPERS POR DISTANCIA
	 * =======================================================
	 */

	getDistanceParticipants(
		distance
	) {

		const normalizedDistance =
			String(
				distance || ''
			).trim();


		if (
			normalizedDistance === ''
		) {

			return [];
		}


		return this.props.participantList.filter(
			(participant) => {

				return (
					String(
						participant.distance || ''
					).trim() ===
					normalizedDistance
				);
			}
		);
	}


	/*
	 * Atletas que efectivamente llegaron.
	 */
	getDistanceCompleted(
		distance
	) {

		const participants =
			this.getDistanceParticipants(
				distance
			);


		return participants.filter(
			(participant) => {

				return (
					participant.registeredTime1 > 0
				);
			}
		);
	}


	/*
	 * DNS por distancia.
	 */
	getDistanceDNS(
		distance
	) {

		const participants =
			this.getDistanceParticipants(
				distance
			);


		return participants.filter(
			(participant) => {

				return this.isDNS(
					participant
				);
			}
		);
	}


	/*
	 * DSQ por distancia.
	 */
	getDistanceDSQ(
		distance
	) {

		const participants =
			this.getDistanceParticipants(
				distance
			);


		return participants.filter(
			(participant) => {

				return this.isDSQ(
					participant
				);
			}
		);
	}


	/*
	 * Etiqueta:
	 *
	 * 182/200
	 * (restan 10, DNS: 5, DSQ: 3)
	 *
	 * 182 representa llegadas reales.
	 */
	getDistanceComplLabel(
		distance
	) {

		const total =
			this.getDistanceParticipants(
				distance
			);


		const completed =
			this.getDistanceCompleted(
				distance
			);


		const dns =
			this.getDistanceDNS(
				distance
			);


		const dsq =
			this.getDistanceDSQ(
				distance
			);


		const llegados =
			completed.length;


		const tot =
			total.length;


		const totalDNS =
			dns.length;


		const totalDSQ =
			dsq.length;


		const resolved =
			llegados +
			totalDNS +
			totalDSQ;


		const rest =
			Math.max(
				0,
				tot - resolved
			);


		let details = [];


		if (
			rest > 0
		) {

			details.push(
				'restan ' +
				rest
			);
		}


		if (
			totalDNS > 0
		) {

			details.push(
				'DNS: ' +
				totalDNS
			);
		}


		if (
			totalDSQ > 0
		) {

			details.push(
				'DSQ: ' +
				totalDSQ
			);
		}


		const detailText =
			details.length > 0

				? ' (' +
					details.join(', ') +
					')'

				: '';


		return (
			llegados +
			'/' +
			tot +
			detailText
		);
	}


	/*
	 * El porcentaje representa atletas
	 * con estado resuelto:
	 *
	 * llegada + DNS + DSQ
	 */
	getDistanceComplPerc(
		distance
	) {

		const total =
			this.getDistanceParticipants(
				distance
			);


		if (
			total.length === 0
		) {

			return 0;
		}


		const completed =
			this.getDistanceCompleted(
				distance
			);


		const dns =
			this.getDistanceDNS(
				distance
			);


		const dsq =
			this.getDistanceDSQ(
				distance
			);


		const resolved =
			completed.length +
			dns.length +
			dsq.length;


		return (
			resolved *
			100 /
			total.length
		);
	}


	/*
	 * =======================================================
	 * DISTANCIA 1
	 * =======================================================
	 */

	getDistance1ComplLabel() {

		return this.getDistanceComplLabel(
			this.props.distance1Type
		);
	}


	getDistance1ComplPerc() {

		return this.getDistanceComplPerc(
			this.props.distance1Type
		);
	}


	/*
	 * =======================================================
	 * DISTANCIA 2
	 * =======================================================
	 */

	getDistance2ComplLabel() {

		return this.getDistanceComplLabel(
			this.props.distance2Type
		);
	}


	getDistance2ComplPerc() {

		return this.getDistanceComplPerc(
			this.props.distance2Type
		);
	}


	/*
	 * =======================================================
	 * DISTANCIA 3
	 * =======================================================
	 */

	getDistance3ComplLabel() {

		return this.getDistanceComplLabel(
			this.props.distance3Type
		);
	}


	getDistance3ComplPerc() {

		return this.getDistanceComplPerc(
			this.props.distance3Type
		);
	}


	/*
	 * =======================================================
	 * COMPETENCIAS DE UNA SOLA LLEGADA
	 * =======================================================
	 *
	 * RuralBike y CombinadaSimple.
	 */

	getSingleRaceStats() {

		const participants =
			this.props.participantList;


		const total =
			participants.length;


		const completed =
			participants.filter(
				(participant) => {

					return (
						participant.registeredTime1 > 0
					);
				}
			).length;


		const dns =
			participants.filter(
				(participant) => {

					return this.isDNS(
						participant
					);
				}
			).length;


		const dsq =
			participants.filter(
				(participant) => {

					return this.isDSQ(
						participant
					);
				}
			).length;


		const resolved =
			completed +
			dns +
			dsq;


		const rest =
			Math.max(
				0,
				total - resolved
			);


		return {
			total,
			completed,
			dns,
			dsq,
			resolved,
			rest
		};
	}


	getSingleRaceComplLabel() {

		const stats =
			this.getSingleRaceStats();


		let details = [];


		if (
			stats.rest > 0
		) {

			details.push(
				'restan ' +
				stats.rest
			);
		}


		if (
			stats.dns > 0
		) {

			details.push(
				'DNS: ' +
				stats.dns
			);
		}


		if (
			stats.dsq > 0
		) {

			details.push(
				'DSQ: ' +
				stats.dsq
			);
		}


		return (
			stats.completed +
			'/' +
			stats.total +
			(
				details.length > 0
					? ' (' +
						details.join(', ') +
						')'
					: ''
			)
		);
	}


	getSingleRaceComplPerc() {

		const stats =
			this.getSingleRaceStats();


		if (
			stats.total === 0
		) {

			return 0;
		}


		return (
			stats.resolved *
			100 /
			stats.total
		);
	}


	/*
	 * =======================================================
	 * COMBINADA SIMPLE
	 * =======================================================
	 */

	getCombinadaSimpleComplLabel() {

		return this.getSingleRaceComplLabel();
	}


	getCombinadaSimpleComplPerc() {

		return this.getSingleRaceComplPerc();
	}


	/*
	 * =======================================================
	 * RURAL BIKE
	 * =======================================================
	 */

	getRuralBikeComplLabel() {

		return this.getSingleRaceComplLabel();
	}


	getRuralBikeComplPerc() {

		return this.getSingleRaceComplPerc();
	}


	render() {

		let active1 =
			this.getPartial1ComplPerc() !== 100;


		let active2 =
			this.getPartial2ComplPerc() !== 100;


		let activeDistance1 =
			this.getDistance1ComplPerc() !== 100;


		let activeDistance2 =
			this.getDistance2ComplPerc() !== 100;


		let activeDistance3 =
			this.getDistance3ComplPerc() !== 100;


		let activeRuralBike =
			this.getRuralBikeComplPerc() !== 100;


		let activeCombinadaSimple =
			this.getCombinadaSimpleComplPerc() !== 100;


		const hasDistance2 =
			String(
				this.props.distance2Type || ''
			).trim() !== '';


		const hasDistance3 =
			String(
				this.props.distance3Type || ''
			).trim() !== '';


		/*
		 * =====================================================
		 * COMBINADA SPRINT
		 * =====================================================
		 */

		let partialBar = (

			<Table>

				<thead>

					<tr>

						<th>
							<h3>
								<center>
									Pedestrismo
								</center>
							</h3>
						</th>

						<th>
							<h3>
								<center>
									Ciclismo
								</center>
							</h3>
						</th>

					</tr>

				</thead>


				<tbody>

					<tr>

						<td>

							<ProgressBar
								striped
								active={
									active1
								}
								now={
									this.getPartial1ComplPerc()
								}
								label={
									`${this.getPartial1ComplLabel()}`
								}
							/>

						</td>


						<td>

							<ProgressBar
								striped
								active={
									active2
								}
								bsStyle="info"
								now={
									this.getPartial2ComplPerc()
								}
								label={
									`${this.getPartial2ComplLabel()}`
								}
							/>

						</td>

					</tr>

				</tbody>

			</Table>
		);


		/*
		 * =====================================================
		 * PEDESTRISMO 2 / 3 DISTANCIAS
		 * =====================================================
		 */

		let multipleBar = (

			<Table>

				<thead>

					<tr>

						<th>

							<h3>
								<center>
									Distancia {this.props.distance1Type}K
								</center>
							</h3>

						</th>


						{
							hasDistance2 &&
							<th>

								<h3>
									<center>
										Distancia {this.props.distance2Type}K
									</center>
								</h3>

							</th>
						}


						{
							hasDistance3 &&
							<th>

								<h3>
									<center>
										Distancia {this.props.distance3Type}K
									</center>
								</h3>

							</th>
						}

					</tr>

				</thead>


				<tbody>

					<tr>

						<td>

							<ProgressBar
								striped
								active={
									activeDistance1
								}
								now={
									this.getDistance1ComplPerc()
								}
								label={
									`${this.getDistance1ComplLabel()}`
								}
							/>

						</td>


						{
							hasDistance2 &&
							<td>

								<ProgressBar
									striped
									active={
										activeDistance2
									}
									bsStyle="info"
									now={
										this.getDistance2ComplPerc()
									}
									label={
										`${this.getDistance2ComplLabel()}`
									}
								/>

							</td>
						}


						{
							hasDistance3 &&
							<td>

								<ProgressBar
									striped
									active={
										activeDistance3
									}
									bsStyle="success"
									now={
										this.getDistance3ComplPerc()
									}
									label={
										`${this.getDistance3ComplLabel()}`
									}
								/>

							</td>
						}

					</tr>

				</tbody>

			</Table>
		);


		/*
		 * =====================================================
		 * PEDESTRISMO UNA DISTANCIA
		 * =====================================================
		 */

		let simpleBar = (

			<Table>

				<thead>

					<tr>

						<th>

							<h3>
								<center>
									Distancia {this.props.distance1Type}K
								</center>
							</h3>

						</th>

					</tr>

				</thead>


				<tbody>

					<tr>

						<td>

							<ProgressBar
								striped
								active={
									activeDistance1
								}
								now={
									this.getDistance1ComplPerc()
								}
								label={
									`${this.getDistance1ComplLabel()}`
								}
							/>

						</td>

					</tr>

				</tbody>

			</Table>
		);


		/*
		 * =====================================================
		 * RURAL BIKE
		 * =====================================================
		 */

		let simpleBarRuralBike = (

			<Table>

				<thead>

					<tr>

						<th>

							<h3>
								<center>
									Rural Bike
								</center>
							</h3>

						</th>

					</tr>

				</thead>


				<tbody>

					<tr>

						<td>

							<ProgressBar
								striped
								active={
									activeRuralBike
								}
								now={
									this.getRuralBikeComplPerc()
								}
								label={
									`${this.getRuralBikeComplLabel()}`
								}
							/>

						</td>

					</tr>

				</tbody>

			</Table>
		);


		/*
		 * =====================================================
		 * COMBINADA SIMPLE
		 * =====================================================
		 */

		let simpleBarCombinadaSimple = (

			<Table>

				<thead>

					<tr>

						<th>

							<h3>
								<center>
									Combinada
								</center>
							</h3>

						</th>

					</tr>

				</thead>


				<tbody>

					<tr>

						<td>

							<ProgressBar
								striped
								active={
									activeCombinadaSimple
								}
								now={
									this.getCombinadaSimpleComplPerc()
								}
								label={
									`${this.getCombinadaSimpleComplLabel()}`
								}
							/>

						</td>

					</tr>

				</tbody>

			</Table>
		);


		return (

			<Grid>


				<Row className="show-grid">

					<Col md={12}>

						{
							this.props.competition ===
								CombinadaSprint
							&&
							partialBar
						}


						{
							(
								(
									this.props.competition ===
										PedestrismoBackup
									||
									this.props.competition ===
										Pedestrismo
								)
								&&
								!hasDistance2
								&&
								!hasDistance3
							)
							&&
							simpleBar
						}


						{
							(
								(
									this.props.competition ===
										PedestrismoBackup
									||
									this.props.competition ===
										Pedestrismo
								)
								&&
								(
									hasDistance2 ||
									hasDistance3
								)
							)
							&&
							multipleBar
						}


						{
							this.props.competition ===
								RuralBike
							&&
							simpleBarRuralBike
						}


						{
							this.props.competition ===
								CombinadaSimple
							&&
							simpleBarCombinadaSimple
						}

					</Col>

				</Row>


				<Row className="show-grid">

					<Col md={6}>

						<h3>
							<center>
								Tiempo
							</center>
						</h3>


						<Table
							responsive
							striped
							bordered
							condensed
							hover
						>

							<thead>

								<tr>

									<th>
										Inicio
									</th>

									<th>
										Fin
									</th>

									<th>
										Duraci&oacute;n
									</th>

								</tr>

							</thead>


							<tbody>

								<tr>

									<td>
										{
											this.getTime(
												this.props.startedAt
											)
										} Hs
									</td>

									<td>
										{
											this.getTime(
												this.props.stoppedAt
											)
										} Hs
									</td>

									<td>
										{
											this.getTotalTime(
												this.props.startedAt,
												this.props.stoppedAt
											)
										} Hs
									</td>

								</tr>

							</tbody>

						</Table>

					</Col>


					<Col md={6}>

						<h3>
							<center>
								Participantes
							</center>
						</h3>


						<Table
							responsive
							striped
							bordered
							condensed
							hover
						>

							<thead>

								<tr>

									<th>
										Total
									</th>

									<th>
										Hombres
									</th>

									<th>
										Mujeres
									</th>

								</tr>

							</thead>


							<tbody>

								<tr>

									<th>
										{
											this.getTotalParticipantes()
										}
									</th>

									<td>
										{
											this.getTotalHombres()
										}
									</td>

									<td>
										{
											this.getTotalMujeres()
										}
									</td>

								</tr>

							</tbody>

						</Table>

					</Col>

				</Row>


				<Row className="show-grid">

					<Col md={6}>

						<BootstrapTable
							key="1"
							data={
								this.getInfo(
									"city"
								)
							}
							pagination
							options={
								this.options
							}
						>

							<TableHeaderColumn
								dataField="id"
								isKey
								hidden
							>
								ID
							</TableHeaderColumn>


							<TableHeaderColumn
								dataField="x"
								width="60%"
								dataSort
								dataAlign="center"
							>
								Ciudad
							</TableHeaderColumn>


							<TableHeaderColumn
								dataField="y"
								width="40%"
								dataSort
							>
								# Participantes
							</TableHeaderColumn>

						</BootstrapTable>

					</Col>


					<Col md={6}>

						<BootstrapTable
							key="2"
							data={
								this.getInfo(
									"category"
								)
							}
							pagination
							options={
								this.options2
							}
						>

							<TableHeaderColumn
								dataField="id"
								isKey
								hidden
							>
								ID
							</TableHeaderColumn>


							<TableHeaderColumn
								dataField="x"
								width="60%"
								dataSort
								dataAlign="center"
							>
								Categor&iacute;a
							</TableHeaderColumn>


							<TableHeaderColumn
								dataField="y"
								width="40%"
								dataSort
							>
								# Participantes
							</TableHeaderColumn>

						</BootstrapTable>

					</Col>

				</Row>


			</Grid>
		);
	}
}


function mapDispatchToProps(
	dispatch
) {

	return bindActionCreators(
		{},
		dispatch
	);
}


function mapStateToProps(
	state
) {

	const {
		infoList,
		participantList,
		catStats
	} =
		state.reducerRegisterTime;


	const {
		startedAt,
		stoppedAt
	} =
		state.reducerTimer;


	const {
		name,
		date,
		place,

		distance1Type,
		distance1Value,

		distance2Type,
		distance2Value,

		distance3Type,
		distance3Value,

		competition
	} =
		state.reducerRegisterInfo;


	return {

		infoList,

		startedAt,

		stoppedAt,

		catStats,


		distance1Type,

		distance1Value,


		distance2Type,

		distance2Value,


		distance3Type,

		distance3Value,


		name,

		date,

		place,

		participantList,

		competition
	};
}


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	RaceStats
);



// WEBPACK FOOTER //
// ./src/containers/race-stats.js